/*
 * Copyright (C) 2025 JPMorgan Chase & Company
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, is not permitted.
 */

import {ExdsButton, ExdsGrid, ExdsLayout} from "@exds/core";
import './Error.scss';
import React, {useContext, useEffect} from "react";
import Alert from "../Alert/Alert";
import {addExitEvent, addPageLoadEvent} from "../AdobeAnalytics/AdobeAnalytics";
import AppContext from "../../AppContext";

export default function Error(
  {
    content,
    buttonTitle,
    correlationId,
    buttonLink,
    externalRedirectLink,
    windowOpenTarget='_self',
    windowDimensions = '',
    pageName,
    sid
  }
) {
  const {loadAA} = useContext(AppContext);
  const errorPageName = pageName + ' | Error';

  useEffect(() => {
    if(loadAA) {
      addPageLoadEvent(pageName + ' | Error', sid);
    }
  }, [loadAA, sid]);// eslint-disable-line react-hooks/exhaustive-deps

  return(
    <ExdsGrid>
      <ExdsLayout
        display="flex"
        flexDirection="column"
        alignItems="center"
        className='error-container'>
        <Alert errorMessage={content} correlationId={correlationId} loadAA={loadAA} pageName={errorPageName} sid={sid}/>
        { buttonTitle &&
          <ExdsButton
            variant="secondary"
            minWidth="288px"
            type="button"
            className="error-button"
            text={buttonTitle}
            onClick={() => {
              if(loadAA && externalRedirectLink) {
                addExitEvent(errorPageName, sid, buttonLink, 'Link', buttonTitle, '');
              }
              window.open(buttonLink, windowOpenTarget, windowDimensions);
            }}
          />
        }
      </ExdsLayout>
    </ExdsGrid>
  ) ;
}
